module.exports = __webpack_public_path__ + "static/media/recept-4.018dbe76.jpg";